module.exports = __webpack_public_path__ + "static/media/gameplay-5.0835e141.png";